export const listItemStyle = {
  flexBasis: "100%",
  margin: "8px 0",
};
